/**
 * Makes action tripplets in conformance with Flux Standard Actions
 *   ACTION_REQUEST, ACTION_SUCCESS, ACTION_FAILURE
 */
export function makeFSATripplet(action) {
  return [
    `${action}_REQUEST`,
    `${action}_SUCCESS`,
    `${action}_FAILURE`
  ];
}



// WEBPACK FOOTER //
// ./src/actions/utils.js